import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { map, take, tap } from 'rxjs/operators';
import { AuthService } from './auth.service';

@Injectable({
    providedIn: 'root'
})
export class AuthGuard implements CanActivate {
    constructor(private auth: AuthService) {}

    canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean | UrlTree> | boolean {
        return this.auth.userInfo$.pipe(
            take(1),
            tap((userInfo) => {
                if (userInfo.isLoggedIn === false) {
                    this.auth.login(state.url);
                }
            }),
            map((userInfo) => userInfo.isLoggedIn)
        );
    }
}
